// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore constants is in the parent dir
import DRUMKIT_AUTH_URL from '@constants/DrumkitAuthUrl';

// Tabs on the portal's Quick Quote Agent page.
export enum AgentPortalTab {
  Rules = 'rules',
  History = 'history',
  Test = 'test',
  Settings = 'settings',
}

// Drumkit Portal page for one Quick Quote Agent, e.g. .../agents/quick-quote/7/edit?tab=rules.
export const buildAgentPortalUrl = (
  agentId: number,
  tab?: AgentPortalTab
): string => {
  const base = `${String(DRUMKIT_AUTH_URL).replace(/\/+$/, '')}/agents/quick-quote/${agentId}/edit`;
  return tab ? `${base}?tab=${tab}` : base;
};
